export const DEFAULT_TRANSPARENCY = 80
